import { LessonOutput } from '@/api/gql/graphql';
import { LessonFormMode } from '@/pages/Lessons/lessons.hook';
import { create } from 'zustand';

type LessonStore = {
  isOpenLessonModal: boolean;
  isOpenUpdateLessonModal: boolean;
  lesson: LessonOutput | null;
  lessonId: string | '';
  formMode: LessonFormMode;
  leconPlainText: string;
  leconHtmlText: string;
  resumePlainText: string;
  resumeHtmlText: string;
  lessonDeletionModal: boolean;
  setIsOpenLessonModal: (isOpen: boolean) => void;
  setIsOpenUpdateLessonModal: (isOpen: boolean) => void;
  openLessonDeletionModal: () => void;
  openUpdateLessonModal: () => void;
  setLesson: (lesson: LessonOutput | null) => void;
  setLessonId: (id: string | '') => void;
  setFormMode: (mode: LessonFormMode) => void;
  setLeconPlainText: (text: string) => void;
  setLeconHtmlText: (html: string) => void;
  setResumePlainText: (text: string) => void;
  setResumeHtmlText: (html: string) => void;
};

export const useLessonStore = create<LessonStore>()((set) => ({
  isOpenLessonModal: false,
  isOpenUpdateLessonModal: false,
  lesson: null,
  lessonId: '',
  formMode: 'create',
  leconPlainText: '',
  leconHtmlText: '',
  resumePlainText: '',
  resumeHtmlText: '',
  lessonDeletionModal: false,
  setIsOpenLessonModal: (isOpen) => set({ isOpenLessonModal: isOpen }),
  setIsOpenUpdateLessonModal: (isOpen) =>
    set({ isOpenUpdateLessonModal: isOpen }),
  openUpdateLessonModal: () =>
    set((state) => ({
      isOpenUpdateLessonModal: !state.isOpenUpdateLessonModal,
    })),
  setLesson: (lesson) => set({ lesson }),
  setLessonId: (id) => set({ lessonId: id }),
  setFormMode: (mode) => set({ formMode: mode }),
  setLeconPlainText: (text) => set({ leconPlainText: text }),
  setLeconHtmlText: (html) => set({ leconHtmlText: html }),
  setResumePlainText: (text) => set({ resumePlainText: text }),
  setResumeHtmlText: (html) => set({ resumeHtmlText: html }),
  openLessonDeletionModal: () =>
    set((state) => ({ lessonDeletionModal: !state.lessonDeletionModal })),
}));
